import { render, staticRenderFns } from "./addRoleDraw.vue?vue&type=template&id=03f6815a&scoped=true"
import script from "./addRoleDraw.vue?vue&type=script&lang=js"
export * from "./addRoleDraw.vue?vue&type=script&lang=js"
import style0 from "./addRoleDraw.vue?vue&type=style&index=0&id=03f6815a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f6815a",
  null
  
)

export default component.exports